import { Controller } from "@hotwired/stimulus"

// NonRichiesto di pages/Rendicontazione.js (31a5bd1): l'operatore dichiara che gli atti non richiedono quel documento,
// con l'atto e il punto. «Non richiesto dagli atti?» apre il campo (il testo scritto resta se si chiude e si riapre);
// «Conferma» si accende con almeno 10 caratteri (nota.trim().length); «chiudi» richiude. L'invio e' del server.
export default class extends Controller {
  static targets = ["apri", "form", "nota", "invia"]

  connect() { this.controlla() }

  apri() {
    this.apriTarget.hidden = true
    this.formTarget.hidden = false
    this.notaTarget.focus()
  }

  chiudi() {
    this.formTarget.hidden = true
    this.apriTarget.hidden = false
  }

  controlla() {
    this.inviaTarget.disabled = this.notaTarget.value.trim().length < 10
  }
}
